import { Box, Icon, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { noScheduledTransactionsCopy } from './constants';

import { trackClick } from '../../features/track';
import { urlBuilder } from '../../Shared/urlBuilder';

export const NoTransactionsRow = () => {
  return (
    <SambaAutoLink
      to={urlBuilder.appDepositSetup.absolute()}
      aria-label="Set up automated savings"
      css={{ textDecoration: 'none!important' }}
      onClick={() => trackClick({ name: 'SetUpAutoDeposit', module: 'ScheduledDeposits', location: 'Summary' })}
    >
      <Box css={{ display: 'flex', justifyContent: 'space-between', padding: 'space.300', alignItems: 'center' }}>
        <Box css={{ display: 'flex', alignItems: 'center' }}>
          <Icon name="ArrowCircle" size="small" color="icon" css={{ marginRight: 'space.100' }} />
          <Text variant="text100" color="text">
            {noScheduledTransactionsCopy}
          </Text>
        </Box>
        <Icon name="CaretRight" size="small" color="icon" />
      </Box>
    </SambaAutoLink>
  );
};
